import React, { useEffect, useRef, useState } from 'react';
import Placeholder from './Placeholder';
import StyledImage from './styles';
import { GenericAssetProps } from '../types';

const GenericAsset = ({ alt = '', url, size = 20, ...rest }: GenericAssetProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true);
  const imageRef = useRef<HTMLImageElement>(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const ref = imageRef.current;

    const onLoad = () => {
      setIsLoading(false);
    };

    if (!ref?.complete) {
      ref?.addEventListener('load', onLoad);
    } else {
      onLoad();
    }

    return () => {
      ref?.removeEventListener('load', onLoad);
    };
  }, []);

  const handleError = () => {
    setHasError(true);
  };

  const imageStyle = isLoading || hasError ? { display: 'none' } : {};
  const displayPlaceholder = isLoading || hasError;

  return (
    <>
      {displayPlaceholder && <Placeholder width={size} height={size} {...rest} />}
      <StyledImage
        alt={alt}
        ref={imageRef}
        width={size}
        height={size}
        src={url}
        onError={handleError}
        style={imageStyle}
        {...rest}
      />
    </>
  );
};

export default GenericAsset;
